// RITA-1585/RITA-1602 — Kachel „Einstellungen › Handbuch“: Handbuch-Auswahl, Kapitelauswahl und Suche über alle Handbücher,
// darunter der Text des Kapitels. Beim ersten Öffnen steht Kapitel 1 der Vertragserstellung, danach das zuletzt gewählte
// Kapitel; Link und Verweise aus der Leiste bringen ihr Ziel über die Adresse mit (`?handbuch=…&kapitel=…&abschnitt=…`).
// Der Seitenkopf kommt weiter über das Barrel pages/Options/components (Seitentitel-Matrix mockt genau diesen Pfad).
import React from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import EinstellungenSeitenKopf from '../../../pages/Options/components';
import useResponsive from '../../../hooks/useResponsive';
import HandbuchGeruest from '../../handbuch/components/HandbuchGeruest';
import useHandbuchLeiste from '../../handbuch/hooks/useHandbuchLeiste';
import {
  ABSCHNITT_PARAMETER,
  HANDBUCH_PARAMETER,
  KAPITEL_PARAMETER,
  kapitelwahlAusAdresse,
} from '../../handbuch/model/handbuchAdresse';
import { Kapitelwahl } from '../../handbuch/model/handbuecher';

export default function HandbuchPage() {
  const [parameter, setParameter] = useSearchParams();
  const leiste = useHandbuchLeiste('kachel', { startkapitel: kapitelwahlAusAdresse(parameter) });
  // Die Adresse folgt der Wahl (ohne Verlaufseintrag): Neuladen und Teilen zeigen das gewählte Kapitel, nicht das
  // mitgebrachte. Beim Öffnen über die Kachel bleibt die Adresse ohne Parameter.
  const waehlen = (wahl: Kapitelwahl, abschnittId?: string) => {
    leiste.waehlen(wahl);
    setParameter(
      {
        [HANDBUCH_PARAMETER]: wahl.handbuchId,
        [KAPITEL_PARAMETER]: wahl.kapitelId,
        ...(abschnittId ? { [ABSCHNITT_PARAMETER]: abschnittId } : {}),
      },
      { replace: true },
    );
  };
  const schmal = useResponsive('down', 'sm');
  return (
    <>
      <EinstellungenSeitenKopf title="Handbuch" />
      <Box sx={{ maxWidth: 720 }}>
        <HandbuchGeruest
          auswahl={leiste.auswahl}
          onAuswahl={waehlen}
          alleHandbuecher
          ueberschrift="h2"
          schmal={schmal}
          startAbschnitt={parameter.get(ABSCHNITT_PARAMETER)}
        />
      </Box>
    </>
  );
}
